import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  findLegalVersion,
  lazyLegalModules,
  loadLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/privacy/*.md"))

export const Route = createFileRoute("/_content/privacy/$date")({
  loader: ({ params }) => loadLegalVersion(modules, params.date),
  head: ({ loaderData }) => {
    if (!loaderData) return {}
    return seoMeta({
      title: `Privacy Policy (${loaderData.dateFormatted})`,
      description: `Archived version of the Entire Privacy Policy from ${loaderData.dateFormatted}.`,
      url: `https://entire.com/privacy/${loaderData.date}`,
      image: "https://entire.com/og/page/privacy.png",
      noindex: true,
    })
  },
  component: PrivacyVersionPage,
})

function PrivacyVersionPage() {
  const { asOf, date } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const version = findLegalVersion(versions, date)!
  return <LegalVersionPage basePath="/privacy" version={version} versions={versions} />
}
